import "./AgentDashboard.scss"

import React, {Fragment, PureComponent} from 'react';
import api from "../../../../../../api.js";
import {generate} from "../../../../../routes.js";
import withCurrentUniverse from "../../../../../HOC/withCurrentUniverse.jsx";

import CheckIcon from '../../../../../../shared/assets/icons/AgentDashboard/check.svg'
import PhoneIcon from '../../../../../../shared/assets/icons/AgentDashboard/phone.svg'
import RelaunchIcon from '../../../../../../shared/assets/icons/AgentDashboard/relaunch.svg'
import CrossIcon from '../../../../../../shared/assets/icons/AgentDashboard/cross.svg'
import CardTitleCheckIcon from '../../../../../../shared/assets/icons/AgentDashboard/CardTitleCheck.svg'
import CardTitleRelaunchIcon from '../../../../../../shared/assets/icons/AgentDashboard/CardTitleRelaunch.svg'
import CardTitleAgendaIcon from '../../../../../../shared/assets/icons/AgentDashboard/CardTitleAgenda.svg'
import CardTitleSearchIcon from '../../../../../../shared/assets/icons/AgentDashboard/CardTitleSearch.svg'
import CardTitleTargetIcon from '../../../../../../shared/assets/icons/AgentDashboard/CardTitleTarget.svg'
import CardTitleUserSearchIcon from '../../../../../../shared/assets/icons/AgentDashboard/CardTitleUserSearch.svg'
import Loader from "../../../../../../shared/components/Loader/Loader.jsx";

import DashboardLayout from '../../../../Layout/DashboardLayout.jsx';
import Navbar from '../../../../Navbar/Navbar.jsx';
import Card from "../../../../../../shared/components/Styled/Dasboard/Card.jsx";
import CardRow from "../../../../../../shared/components/Styled/Dasboard/CardRow.jsx";
import CardCol from "../../../../../../shared/components/Styled/Dasboard/CardCol.jsx";
import MomentDate from "../../../../../../shared/components/Moment/Date.jsx";

import {
  FOLLOW_SHORTCUT_KEY,
  MET_TO_RELAUNCH_SHORTCUT_KEY,
  TO_VALIDATE_SHORTCUT_KEY
} from "../../../../../../shared/components/FreelanceList/constant";

class AgentDashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      dashboardData: {
        clientSearches: [],
        incompleteToRemind: [],
        offers: [],
        searches: [],
        stats: {},
        toRemind: [],
        toValidate: [],
      }
    }

    this.loadData()
  }

  fetch = async () => {
    return {
      clientSearches: (await api.agent.clientSearches()).data,
      incompleteToRemind: (await api.agent.incompleteToRemind()).data,
      offers: (await api.agent.offers()).data,
      searches: (await api.agent.searches()).data,
      stats: (await api.agent.stats()).data,
      toRemind: (await api.agent.toRemind()).data,
      toValidate: (await api.agent.toValidate()).data,
    }
  }
  loadData = async () => {
    try {
      this.setState({
        dashboardData: await this.fetch()
      })
    }
    catch (error) {
      console.error({error})
    }
    finally {
      this.setState({
        loading: false,
      })
    }
  }
  buildSearchFreelanceProfileLink = (search) => {
    return  generate({
      name: 'profiles',
      search: {
        ...((search) ? search: {})
      }
    })
  }
  buildOfferLink = (search) => {
    return  generate({
      name: 'offers.search.results',
      search: {
        manager: this.props.user.id,
        // universe: this.props.currentUniverse.id,
        ...((search) ? search: {})
      }
    })
  }

  isDateLate = (isoDate) => {
    return (new Date()).toISOString() > isoDate
  }


  render() {
    const {dashboardData, loading} = this.state

    const stats = {
      incompleteToRemind: dashboardData?.stats.incompleteToRemind ?? 0,
      toRemind: dashboardData?.stats.toRemind ?? 0,
      toValidate: dashboardData?.stats.toValidate ?? 0,
      total: dashboardData?.stats.total ?? 0,
    }

    if(loading) {
      return <Loader visible={loading}>Chargement des informations...</Loader>
    }

    return (
      <DashboardLayout navbar={this.props.navbar ? <Navbar locked={true}/> : null}>
        <div className="bg-gray-200 print-no-color py-2 py-sm-5">
          <div className="container dashboard-agent-container">

            <div className="dashboard-row">
              <div className="dashboard-col">
                <Card
                  className={'dashboard-card-primary dashboard-advisory-card'}
                  title={<Fragment>
                      Sur mes {stats.total} Consultants
                  </Fragment>}>
                  <CardRow  align="center">
                    <CardCol>
                      <CardRow className="dashboard-advisory-card-row" align="center" p={0} gap="7px">
                        <CardCol className="stats-to-validate" flex="unset">
                          <img src={CheckIcon} alt="check" className="agent-dashboard-header-icon"/>
                        </CardCol>
                        <CardCol>
                          {stats.toValidate} profils à valider
                        </CardCol>
                      </CardRow>
                    </CardCol>
                    <CardCol>
                      <CardRow className="dashboard-advisory-card-row" align="center" p={0} gap="7px">
                        <CardCol className="stats-incomplete" flex="unset" >
                          <img src={RelaunchIcon} alt="relaunch" className="agent-dashboard-header-icon"/>
                        </CardCol>
                        <CardCol>
                          {stats.incompleteToRemind} profils non complets à relancer
                        </CardCol>
                      </CardRow>
                    </CardCol>
                    <CardCol>
                      <CardRow className="dashboard-advisory-card-row" align="center" p={0} gap="7px">
                        <CardCol className="stats-to-remind" flex="unset">
                          <img src={PhoneIcon} alt="phone" className="agent-dashboard-header-icon"/>
                        </CardCol>
                        <CardCol>
                          {stats.toRemind} suivis consultant à réaliser
                        </CardCol>
                      </CardRow>
                    </CardCol>
                  </CardRow>
                </Card>
              </div>
            </div>
            <div className="dashboard-row">
              <div className="dashboard-col">
                <Card
                  className="dashboard-agent"
                  title={<Fragment>
                    <img src={CardTitleCheckIcon} alt=""/>
                           Profils à valider
                  </Fragment>}>
                  {this.state.dashboardData.toValidate.map((toValidate, index) => {
                    return (
                      <div className="dashboard-agent-row" style={{display: 'flex'}} key={`dashboard-agent-incomplete-to-validate-${index}`}>
                        <div className="dashboard-agent-row-col dashboard-agent-title">{toValidate?.user.fullname ?? null}</div>
                        <div className="dashboard-agent-row-col dashboard-agent-date">
                            Profils à valider
                        </div>
                      </div>
                    )
                  })}
                  <CardRow className="dashboard-agent-card-row-cta-container">
                    <CardCol flex="unset">
                      <a
                        href={this.buildSearchFreelanceProfileLink({
                          shortcut: TO_VALIDATE_SHORTCUT_KEY
                        })}
                        className="btn btn-primary">
                            Voir tous les profils non complets
                      </a>
                    </CardCol>
                  </CardRow>
                </Card>
              </div>
              <div className="dashboard-col">
                <Card
                  className="dashboard-agent"
                  title={<Fragment>
                    <img src={CardTitleRelaunchIcon} alt=""/>
                    Profils non complets à relancer
                  </Fragment>}>

                  {this.state.dashboardData.incompleteToRemind.map((remind, index) => {
                    return (
                      <div className="dashboard-agent-row" style={{display: 'flex'}}
                        key={`dashboard-agent-incomplete-to-remind-${index}`}>
                        <div
                          className="dashboard-agent-row-col dashboard-agent-title">{remind?.user.fullname ?? null}</div>
                        <div className="dashboard-agent-row-col dashboard-agent-date">
                          Informations à compléter
                        </div>
                      </div>
                    )
                  })}
                  <CardRow className="dashboard-agent-card-row-cta-container">
                    <CardCol flex="unset">
                      <a
                        href={this.buildSearchFreelanceProfileLink({
                          shortcut: MET_TO_RELAUNCH_SHORTCUT_KEY
                        })}
                        className="btn btn-primary">
                        Voir tous les profils non complets à relancer
                      </a>
                    </CardCol>
                  </CardRow>
                </Card>
              </div>
            </div>
            <div className="dashboard-row">
              <div className="dashboard-col">
                <Card
                  className="dashboard-agent"
                  title={<Fragment>
                    <img src={CardTitleAgendaIcon} alt=""/>
                    Suivi consultant : date de relance
                  </Fragment>}>
                  {this.state.dashboardData.toRemind.map((remind, index) => {
                    return (
                      <div className="dashboard-agent-row" style={{display: 'flex'}}
                        key={`dashboard-agent-to-remind-${index}`}>
                        <div
                          className="dashboard-agent-row-col dashboard-agent-title">{remind?.user.fullname ?? null}</div>
                        <div className="dashboard-agent-row-col dashboard-agent-date">
                          {<MomentDate format="dd/MM/yyyy" date={remind.date_next_action}/>}
                        </div>
                        <div className="dashboard-agent-row-col dashboard-agent-status">
                          {this.isDateLate(remind.date_next_action) ? <img src={CrossIcon} alt="late"/> :
                            <img src={CheckIcon} alt="relaunch"/>}
                        </div>
                      </div>
                    )
                  })}
                  <div className="dashboard-agent-row-col dashboard-agent-status">
                    <CardRow className="dashboard-agent-card-row-cta-container">
                      <CardCol flex="unset">
                        <a
                          href={this.buildSearchFreelanceProfileLink({
                            shortcut: FOLLOW_SHORTCUT_KEY
                          })}
                          className="btn btn-primary">
                            Voir tous les profils à relancer
                        </a>
                      </CardCol>
                    </CardRow>
                  </div>
                </Card>
              </div>
              <div className="dashboard-col">
                <Card
                  className="dashboard-agent"
                  title={<Fragment>
                    <img src={CardTitleTargetIcon} alt=""/>
                      Missions publiées
                  </Fragment>}>

                  {this.state.dashboardData.offers.map((offer, index) => {
                    return (
                      <div className="dashboard-agent-row" style={{display: 'flex'}}
                        key={`dashboard-agent-offer-${index}`}>
                        <div className="dashboard-agent-row-col dashboard-agent-title">{offer.title}</div>
                        <div className="dashboard-agent-row-col dashboard-agent-date">
                          {<MomentDate format="dd/MM/yyyy" date={offer.created_at}/>}
                        </div>
                      </div>
                    )
                  })}
                  <CardRow className="dashboard-agent-card-row-cta-container">
                    <CardCol flex="unset">
                      <a
                        href={this.buildOfferLink()}
                        className="btn btn-primary">
                          Voir mes annonces postées
                      </a>
                    </CardCol>
                  </CardRow>
                </Card>
              </div>
            </div>

            <div className="dashboard-row">
              <div className="dashboard-col">
                <Card
                  className="dashboard-agent"
                  title={<Fragment>
                    <img src={CardTitleSearchIcon} alt=""/>
                      Mes dernières recherches
                  </Fragment>}>

                  {this.state.dashboardData.searches.map((search, index) => {
                    return (
                      <div className="dashboard-agent-row" style={{display: 'flex'}} key={`dashboard-agent-search-${index}`}>
                        <div className="dashboard-agent-row-col dashboard-agent-title">{search.keywords}</div>
                        <div className="dashboard-agent-row-col dashboard-agent-date">
                          {<MomentDate format="dd/MM/yyyy" date={search.created_at}/>}
                        </div>
                      </div>
                    )
                  })}
                </Card>
              </div>

              <div className="dashboard-col">
                <Card
                  className="dashboard-agent"
                  title={<Fragment>
                    <img src={CardTitleUserSearchIcon} alt=""/>
                      Dernières recherches clients
                  </Fragment>}>

                  {this.state.dashboardData.clientSearches.map((search, index) => {
                    return (
                      <div className="dashboard-agent-row" style={{display: 'flex'}} key={`dashboard-agent-client-search-${index}`}>
                        <div className="dashboard-agent-row-col dashboard-agent-title">{search.keywords}</div>
                        <div className="dashboard-agent-row-col dashboard-agent-date">
                          {<MomentDate format="dd/MM/yyyy" date={search.created_at}/>}
                        </div>
                      </div>
                    )
                  })}
                </Card>
              </div>
            </div>

          </div>
        </div>
      </DashboardLayout>
    );
  }
}

export default  withCurrentUniverse(AgentDashboard)
